import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { 
  FaFacebook, 
  FaTwitter, 
  FaLinkedin, 
  FaInstagram, 
  FaEnvelope, 
  FaPhone, 
  FaMapMarkerAlt 
} from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: ${props => props.theme.colors.secondaryColor};
  color: ${props => props.theme.colors.white};
  padding: 80px 0 20px;
`;

const FooterContent = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-bottom: 40px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const FooterLogo = styled.div`
  h3 {
    color: ${props => props.theme.colors.white};
    margin-bottom: 10px;
  }
  
  p {
    color: ${props => props.theme.colors.grey[400]};
  }
`;

const FooterSection = styled.div`
  h4 {
    color: ${props => props.theme.colors.white};
    margin-bottom: 20px;
    position: relative;
    padding-bottom: 10px;
    
    &::after {
      content: '';
      position: absolute;
      display: block;
      width: 30px;
      height: 2px;
      background: ${props => props.theme.colors.primaryColor};
      bottom: 0;
      left: 0;
      
      @media (max-width: ${props => props.theme.breakpoints.sm}) {
        left: 50%;
        transform: translateX(-50%);
      }
    }
  }
`;

const FooterLinks = styled.ul`
  list-style: none;
  
  li {
    margin-bottom: 10px;
  }
  
  a {
    color: ${props => props.theme.colors.grey[400]};
    transition: ${props => props.theme.transitions.main};
    
    &:hover {
      color: ${props => props.theme.colors.white};
      padding-left: 5px;
    }
  }
`;

const ContactItem = styled.li`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    justify-content: center;
  }
  
  svg {
    color: ${props => props.theme.colors.primaryColor};
    margin-right: 10px;
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 15px;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    justify-content: center;
  }
  
  a {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: rgba(255, 255, 255, 0.1);
    color: ${props => props.theme.colors.white};
    transition: ${props => props.theme.transitions.main};
    
    &:hover {
      background-color: ${props => props.theme.colors.primaryColor};
      transform: translateY(-5px);
    }
  }
`;

const FooterBottom = styled.div`
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <div className="container">
        <FooterContent>
          <FooterLogo>
            <h3>KALS Academy</h3>
            <p>Structural Design Academy & Research Centre</p>
          </FooterLogo>
          
          <FooterSection>
            <h4>Quick Links</h4>
            <FooterLinks>
              <li><Link to="/tnpsc">TNPSC Exam</Link></li>
              <li><Link to="/portfolio">Portfolio</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </FooterLinks>
          </FooterSection>
          
          <FooterSection>
            <h4>Contact Information</h4>
            <FooterLinks>
              <ContactItem>
                <FaEnvelope />
                <span>kalsacademy1@gmail.com</span>
              </ContactItem>
              <ContactItem>
                <FaPhone />
                <span>+91 9444108728</span>
              </ContactItem>
              <ContactItem>
                <FaMapMarkerAlt />
                <span>Chennai, Tamil Nadu, India</span>
              </ContactItem>
            </FooterLinks>
          </FooterSection>
          
          <FooterSection>
            <h4>Follow Us</h4>
            <SocialIcons>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                <FaFacebook />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                <FaTwitter />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                <FaLinkedin />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                <FaInstagram />
              </a>
            </SocialIcons>
          </FooterSection>
        </FooterContent>
        
        <FooterBottom>
          <p>&copy; {currentYear} KALS Academy. All Rights Reserved.</p>
        </FooterBottom>
      </div>
    </FooterContainer>
  );
};

export default Footer;